const routes = [
  {
    path: '/answer-settings',
    name: 'answer-settings',
    component: () => import('./index.vue'),
    meta: {
      title: 'Инструкции',
      role: ['admin'],
    },
  },

];

export default routes;
